import countryList from "../../../../apps/quickstage-bff-web/src/services/countryList.json";
import {
  ADDRESS_LINE_MAX_LENGTH,
  CITY_FIELD_MAX_LENGTH,
  POSTAL_CODE_MAX_LENGTH,
  sanitizeAddressLineInput,
  sanitizePostalCodeInput,
  US_STATE_FIELD_MAX_LENGTH,
} from "./addressFieldValidation";
import { sanitizeCityInput, sanitizeUsStateInput } from "./personNameValidation";

export type ParsedSenderAddress = {
  line1: string;
  line2: string;
  city: string;
  zip: string;
  state: string;
};

function getUSStateCode(region?: string, countryCode?: string): string {
  if (!region || countryCode !== "USA") {
    return "";
  }

  const usa = (countryList as { CountryCode?: string; States?: Array<{ stateName: string; stateAbbrivation: string }> }[]).find(
    (c) => c?.CountryCode === "USA"
  );
  if (!usa?.States) {
    return "";
  }

  const state = usa.States.find(
    (s) => s.stateName.toLowerCase() === region.trim().toLowerCase()
  );
  return state?.stateAbbrivation ?? "";
}

/** Map AWS Location `GetPlace` payload into send-flow address fields. */
export function parsePlaceDetailsForSenderAddress(
  place: Record<string, unknown> | null | undefined
): ParsedSenderAddress {
  const p = place ?? {};
  const rawLine1 =
    `${String(p.AddressNumber ?? "")} ${String(p.Street ?? "")}`.trim() ||
    String(p.Label ?? "")
      .split(",")[0]
      ?.trim() ||
    "";

  const line2Raw = String(
    p.Unit ?? p.AddressNumber2 ?? p.SubAddress ?? p.Building ?? ""
  ).trim();

  const rawCity =
    String(p.Municipality ?? "").slice(0, CITY_FIELD_MAX_LENGTH) ||
    String(p.Neighborhood ?? "").slice(0, CITY_FIELD_MAX_LENGTH) ||
    "";

  const rawZip = String(p.PostalCode ?? "");
  const country = String(p.Country ?? "USA");
  const rawState =
    getUSStateCode(String(p.Region ?? ""), country) ||
    String(p.Region ?? "")
      .slice(0, US_STATE_FIELD_MAX_LENGTH)
      .toUpperCase();

  return {
    line1: sanitizeAddressLineInput(rawLine1).slice(0, ADDRESS_LINE_MAX_LENGTH),
    line2: sanitizeAddressLineInput(line2Raw).slice(0, ADDRESS_LINE_MAX_LENGTH),
    city: sanitizeCityInput(rawCity, CITY_FIELD_MAX_LENGTH),
    zip: sanitizePostalCodeInput(rawZip).slice(0, POSTAL_CODE_MAX_LENGTH),
    state: sanitizeUsStateInput(rawState).slice(0, US_STATE_FIELD_MAX_LENGTH),
  };
}
